import styles from './InventoryObjectDescription.module.sass';
import Image from "next/image";
import cn from "classnames";
const InventoryObjectDescription = ({ object, selectedItem, setSelectedItem, isPointer = false}) => {

	return (
		  <div className={cn(styles.object, {[styles.selected]: selectedItem === object.id }, {['custom_pointer']: isPointer})} onClick={() => {
				  isPointer && setSelectedItem(object.id)
		  }}>
			  {/*Image*/}
			  <div className={styles.image}>
				  <svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" viewBox="0 0 62 62" fill="none" className={styles.image__background}>
					  <path d="M62 6.73913V53.913H60.6552V56.6087H59.3103V57.9565H56.6222V59.3043H55.2773V60.6522H53.9325V62H8.06749V60.6522H6.72266V59.3043H5.37783V57.9565H2.68966V56.6087H1.34483V53.913H0V6.73913H1.34483L1.34783 4.04348H2.69565V2.69565H5.3913V1.34783H8.08696V0H53.913V1.34783H56.6087V2.69565H59.3043V4.04348H60.6522L60.6552 6.73913H62Z"
					        fill="#D8D3AF"/>
				  </svg>
				  <div className={styles.image__img} >
				    <Image src={object.src} alt={object.alt} fill sizes={'4rem'}/>
				  </div>
			  </div>

			  {/*Name*/}
			  <span className={styles.name}>{object.name}</span>

			  {/*Description*/}
			  <span className={styles.description}>{object.description}</span>

			  <div className={styles.close} onClick={() => {
				  setSelectedItem(null)
			  }}>X</div>
		  </div>
	);
}

export default InventoryObjectDescription;